import { EXERCISES_ACTION, EXERCISES_PATH } from '../../constants'
import getByIdExerciseSelector from '../../selectors/get-by-id'
import { setIdReduxAction } from '../../../../redux'

function updateCurrentIdExerciseAction (id) {
  return (dispatch, getState) => {
    const exercise = getByIdExerciseSelector(id)(getState())
    dispatch(setIdReduxAction({
      type: EXERCISES_ACTION.UPDATE_CURRENT,
      payload: {
        path: EXERCISES_PATH.CURRENT,
        instance: exercise
      }
    }))
  }
}

export { updateCurrentIdExerciseAction }
